import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import QueryString from 'query-string';
import * as Utils from '../../utils/utils';
import ProfileView from './profile/ProfileView';
import PaymentCardsView from './payments/PaymentCardsView';
import OrderListView from './orders/OrderListView';
import Loader from '../../components/commons/loader/loader';
import * as UserActions from '../../actions/userActions';
import * as TokenHelpers from '../../utils/tokenHelpers';
import * as Cart from '../../utils/cartHelper';
import * as FBinit from '../../utils/fbintit';

class SettingsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeView: 'profile'
    }

    this.renderPageTitle = this.renderPageTitle.bind(this);
    this.renderActiveView = this.renderActiveView.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
  }

  componentDidMount() {

    const {location} = this.props;
    let params = QueryString.parse(location.search);
    if(params && params.edit) this.setState({activeView: params.edit})
  }

  componentWillReceiveProps(newProps) {

    const {location} = this.props;
    let params = QueryString.parse(newProps.location.search);
    if (location.search !== newProps.location.search) this.setState({activeView: params.edit})
  }

  render() {

    console.log("SETTINGS_PAGE_PROPS", this.props);
    const {activeView} = this.state;
    const {loading} = this.props;
    return (
      <div className="page settings-page">
        <div className="container content-container">
          <div className="account-layout">
            <div className="account-header">
              <div className="account-title-group">
                <p className="eyebrow">My Account</p>
                {this.renderPageTitle()}
              </div>
              <button className="sign-out" onClick={this.handleSignOut}>Sign Out</button>
            </div>
            <div className="account-tabs">
              <button className={activeView === 'profile' ? 'active' : ''} onClick={() => this.props.history.push({pathname: '/settings', search: '?edit=profile'})}>Account</button>
              <button className={activeView === 'orders' ? 'active' : ''} onClick={() => this.props.history.push({pathname: '/settings', search: '?edit=orders'})}>Orders</button>
              <button className={activeView === 'addresses' ? 'active' : ''} onClick={() => this.props.history.push({pathname: '/settings', search: '?edit=addresses'})}>Addresses</button>
              <button className={activeView === 'payment-methods' ? 'active' : ''} onClick={() => this.props.history.push({pathname: '/settings', search: '?edit=payment-methods'})}>Payments</button>
            </div>
            <div className="account-content">
              {this.renderActiveView()}
            </div>
          </div>
        </div>
        <Loader visibility={loading} />
      </div>
    )
  }

  renderPageTitle() {

    const {activeView} = this.state;
    let pageTitle = Utils.toTitleCase(activeView ? activeView.replace(new RegExp('-', 'g'), " ") : 'Settings');

    return (
      <h1 className="page-title">{pageTitle}</h1>
    )
  }

  renderActiveView() {

    const {activeView} = this.state;
    switch(activeView) {
      case 'profile':
        return <ProfileView {...this.props}/>

      case 'addresses':
        return <ProfileView {...this.props} focusSection="addresses" />

      case 'payment-methods':
        return <PaymentCardsView {...this.props}/>

      case 'orders':
        return <OrderListView {...this.props} />

      default:
        return null;
    }
  }

  handleSignOut() {
    this.props.dispatch(UserActions.resetUserData());
    TokenHelpers.destroy();
    Cart.clearCart();
    FBinit.FBlogout();
    this.props.history.push('/');
  }
}

export default connect((state) => {
  return {
    orders: state.getIn(['orders', 'orders']),
    loading: (state.getIn(['users', 'loading']) || state.getIn(['payments', 'loading']) || state.getIn(['orders', 'loading'])),
    error: state.getIn(['users', 'error'])
  };
})(SettingsPage);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsPage.js